import { __assign, __read } from "tslib";
import React from 'react';
import { WidthObserver } from '@atlaskit/editor-common';
import { widthToToolbarSize } from './toolbar-size';
import { Toolbar } from './Toolbar';
export var ToolbarWithSizeDetector = function (props) {
    var _a = __read(React.useState(undefined), 2), width = _a[0], setWidth = _a[1];
    var toolbarSize = widthToToolbarSize(width || 0, props.appearance);
    return (React.createElement("div", { style: { width: '100%', minWidth: '254px', position: 'relative' } },
        React.createElement(WidthObserver, { setWidth: setWidth }),
        width === undefined ? null : (React.createElement(Toolbar, __assign({}, props, { toolbarSize: toolbarSize })))));
};
//# sourceMappingURL=ToolbarWithSizeDetector.js.map